const useContactNumberClickHandler = (el) => {
    const {
        sourceField,
        targetField,
    } = el.dataset;

    document.getElementById(targetField).value = document.getElementById(sourceField).value;
};

const upgradeFormHandlers = () => {
    document.querySelectorAll('[data-use-contact-number-button]')
        .forEach((el) => {
            el.addEventListener('click', () => useContactNumberClickHandler(el));
        });
};

export default upgradeFormHandlers;
